import React, { FC, useEffect, useState } from "react";
import { IUsers } from "../../../models/IUsers";

interface IUserForm {
  data: IUsers;
}

interface IFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dateOfBirth: string;
  address: string;
}

const UserForm: FC<IUserForm> = ({ data }) => {
  const [formData, setFormData] = useState<IFormData>({} as IFormData);

  function getName(type: string) {
    const name = data.name.split(" ");
    return type === "first" ? name[0] : name[1];
  }

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setFormData({
        ...formData,
        firstName: getName("first"),
        lastName: getName("last"),
        email: data.email,
        phone: data.phone,
        dateOfBirth: !data.dateOfBirth
          ? ""
          : new Date(data.dateOfBirth).toDateString(),
        address: data.address,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <form className="user-form">
      {/* TODO: Edit user profile options  */}
      <div className="section-content">
        <ul className="info-list">
          <li className="info-piece">
            <div className="piece-title">First name</div>
            <div className="piece-value">{formData.firstName}</div>
          </li>
          <li className="info-piece">
            <div className="piece-title">Last name</div>
            <div className="piece-value">{formData.lastName}</div>
          </li>
          <li className="info-piece">
            <div className="piece-title">Address</div>
            <div className="piece-value">{formData.address}</div>
          </li>
          <li className="info-piece">
            <div className="piece-title">Email</div>
            <div className="piece-value">{formData.email}</div>
          </li>
          <li className="info-piece">
            <div className="piece-title">Phone</div>
            <div className="piece-value">{formData.phone}</div>
          </li>
          <li className="info-piece">
            <div className="piece-title">Birthday</div>
            <div className="piece-value">{formData.dateOfBirth}</div>
          </li>
        </ul>
      </div>
    </form>
  );
};

export default UserForm;
